import {
  Text,
  cn,
  NoContent,
  ErrorContent,
  IllustrationDone,
} from '@bbl-digital/snorre-v2'
import { FC } from 'react'

type WithIllustration = {
  illustration: React.ReactNode
  variant?: never
}

type WithVariant = {
  variant: 'no-content' | 'error-content' | 'completed-content'
  illustration?: never
}

type WithoutIllustrationOrVariant = {
  illustration?: never
  variant?: never
}

type NoResultsProps = (
  | WithIllustration
  | WithVariant
  | WithoutIllustrationOrVariant
) & {
  text: string
  hasSearch?: boolean
  className?: string
}

const NoResults: FC<NoResultsProps> = ({
  text,
  hasSearch,
  illustration,
  variant,
  className,
}) => {
  const msg = (hasSearch && 'Ditt søk ga ingen treff') || text
  const hasTopContent = illustration || variant

  return (
    <div
      className={cn(
        'flex flex-col items-center text-center max-w-[500px] justify-self-center gap-2',
        '[&>div]:max-w-[450px] [&>h3]:mt-6 [&>h4]:mt-2 [&>h4]:w-[65%] md:[&>h4]:w-full',
        hasTopContent ? 'mt-16' : 'mt-4',
        className
      )}
    >
      {illustration}
      {variant === 'no-content' && <NoContent />}
      {variant === 'error-content' && <ErrorContent />}
      {variant === 'completed-content' && <IllustrationDone />}

      <Text align="center" weight="semibold">
        {msg}
      </Text>
    </div>
  )
}

export default NoResults
